import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, Wand2 } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

// Redessine les visuels des diapos FISLApp depuis les vraies données + rapport IA du stagiaire choisi
export const VisuelsDialog = ({ open, session, onClose, onFait }) => {
  const [stagiaires, setStagiaires] = useState([]);
  const [choix, setChoix] = useState('');
  const [charge, setCharge] = useState(false);
  useEffect(() => {
    if (open) axios.get('/stagiaires').then(({ data }) => setStagiaires(data || [])).catch(() => setStagiaires([]));
  }, [open]);
  const lancer = async () => {
    setCharge(true);
    try {
      const { data } = await axios.post('/presentation-centre/jury-plenier/visuels', { stagiaire_id: choix, session }, { timeout: 180000 });
      onFait(data);
      toast.success('Visuels FISLApp mis à jour sur les 2 diapositives');
      onClose();
    } catch (e) { toast.error(e.response?.data?.detail || 'Impossible de refaire les visuels'); }
    finally { setCharge(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && !charge && onClose()}>
      <DialogContent data-testid="visuels-dialog">
        <DialogHeader>
          <DialogTitle>Refaire les visuels FISLApp</DialogTitle>
          <DialogDescription>
            Session {session || '—'} : graphiques, classement et système de notation de la promo, puis parcours, progression et rapport d'analyse IA du stagiaire choisi.
            L'analyse IA est générée si elle n'existe pas encore cette semaine (environ 30 secondes).
          </DialogDescription>
        </DialogHeader>
        <Select value={choix} onValueChange={setChoix}>
          <SelectTrigger data-testid="visuels-stagiaire"><SelectValue placeholder="Choisir le stagiaire à présenter" /></SelectTrigger>
          <SelectContent>
            {stagiaires.map((s) => <SelectItem key={s.user_id} value={s.user_id} data-testid={`visuels-stagiaire-${s.user_id}`}>{s.prenom} {s.nom}</SelectItem>)}
          </SelectContent>
        </Select>
        <DialogFooter>
          <button type="button" onClick={lancer} disabled={!choix || charge} data-testid="visuels-lancer"
            className="inline-flex items-center gap-2 rounded-full bg-[#0F172A] px-5 py-2 text-sm font-bold text-white transition-colors hover:bg-[#1E293B] disabled:opacity-50">
            {charge ? <Loader2 className="h-4 w-4 animate-spin" /> : <Wand2 className="h-4 w-4" />} {charge ? 'Création en cours…' : 'Refaire les visuels'}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
